import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import GeneralHelper from '../../modules/General.js';
import OptionColumn from "../../components/general/OptionColumn";
import SplitRows from '../../components/general/SplitRow.js';
import General from '../../modules/General.js';
import moment from 'moment';
import Switch from 'rc-switch';
import NewRecommendationForm from "./NewRecommendationForm";

class NewRecommendation extends React.Component {
    constructor(props) {
        super(props);
    }

    getRecommendationId() {
        return this.props.router.params.recommendation_id;
    }

    handleSave = (data) => {
        this.props.router.push(General.Link('/recommendations/'+data));
    }

    render() {
        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-users"></i> New recommendation</span>
                    <div className="page-header-actions">
                        <Link to={GeneralHelper.Link("/recommendations")} className="btn btn-dark"><i className="icon fa-arrow-left" style={{marginRight:'10px'}}></i>  Back</Link>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Recommendations | Crall.io" />

                    <NewRecommendationForm onSubmit={this.handleSave} hasSearch={this.props.general.settings.PACKAGE_SEARCH} hasRecommendation={this.props.general.settings.PACKAGE_RECOMMENDATIONS} enabled={this.props.general.settings.PACKAGE_RECOMMENDATIONS || this.props.general.settings.PACKAGE_SEARCH} recommendationId={this.getRecommendationId()} />
                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


NewRecommendation = connect(mapStateToProps,mapDispatchToProps)(NewRecommendation);
export default NewRecommendation;



// WEBPACK FOOTER //
// ./containers/recommendations/new.js